var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4551L10.4476 20.9102L20.8953 10.4551L10.4476 0L0 10.4551Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8953 10.4551L42.3429 20.9102L52.7905 10.4551L42.3429 0L31.8953 10.4551Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7905 10.4551L74.2382 20.9102L84.6858 10.4551L74.2382 0L63.7905 10.4551Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6858 10.4551L106.133 20.9102L116.581 10.4551L106.133 0L95.6858 10.4551Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.581 10.4551L138.029 20.9102L148.476 10.4551L138.029 0L127.581 10.4551Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 44.55L10.5526 55L21.1051 44.55L10.5526 33.9166L0 44.55Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8428 44.55L42.3953 55L52.9479 44.55L42.3953 33.9166L31.8428 44.55Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6855 44.55L74.2381 55L84.7907 44.55L74.2381 33.9166L63.6855 44.55Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5283 44.55L106.081 55L116.633 44.55L106.081 33.9166L95.5283 44.55Z",
    fill: "#CCDEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.371 44.55L137.924 55L148.476 44.55L137.924 33.9166L127.371 44.55Z",
    fill: "#CCDEE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleDots);
export default __webpack_public_path__ + "static/media/TitleDots.a3158275598aa48eacc9ecae62f46972.svg";
export { ForwardRef as ReactComponent };